var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6789_44880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1178 55.8823 0 36 0C16.1177 0 0 16.1178 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5256 29.417L37.4795 33.4874L42.2631 31.9363L39.3046 36.0032L42.2581 40.0734L37.4761 38.5164L34.5178 42.5833L34.5209 37.5544L29.7388 35.9974L34.5226 34.4463L34.5256 29.417Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.465 46.1738C20.8462 46.1738 16.291 41.6187 16.291 35.9998C16.291 30.381 20.8462 25.8259 26.465 25.8259C28.2169 25.8259 29.8653 26.269 31.3044 27.0488C29.0467 24.8407 25.959 23.478 22.5519 23.478C15.6363 23.478 10.0303 29.0842 10.0303 35.9997C10.0303 42.9152 15.6364 48.5214 22.5519 48.5214C25.9593 48.5214 29.0469 47.1586 31.3044 44.9506C29.8653 45.7307 28.2169 46.1738 26.465 46.1738V46.1738Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6789_44880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/turkey.dfadfcb37dc7e71806484f9fbd8f8953.svg";
export { ForwardRef as ReactComponent };